import React__default, { createContext, useContext } from 'react';

const ConsentManifestGeneratorContext = /*#__PURE__*/ createContext(undefined);
const TrustedAuthTokenParamsContext = /*#__PURE__*/ createContext(undefined);
const IDPContextProvider = ({ children, consentManifestGenerator, authTokenParams })=>{
    return /*#__PURE__*/ React__default.createElement(ConsentManifestGeneratorContext.Provider, {
        value: consentManifestGenerator
    }, /*#__PURE__*/ React__default.createElement(TrustedAuthTokenParamsContext.Provider, {
        value: authTokenParams
    }, children));
};
const useConsentManifestGenerator = ()=>useContext(ConsentManifestGeneratorContext);
const useTrustedAuthTokenParams = ()=>useContext(TrustedAuthTokenParamsContext);

export { IDPContextProvider, useConsentManifestGenerator, useTrustedAuthTokenParams };
//# sourceMappingURL=IDPContextProvider.mjs.map
